import { atom } from "kho";
import type { Vec3 } from "./model";
import type { SurfaceSampler } from "../factory/createSurfaceSampler";

/**
 * Surface-picking atoms. Follows the kho taxonomy split:
 *  - $surfaceSampler holds the LIVE GPU sampler instance (created by
 *    surfaceSystem when a renderer is available), consumed by gizmoSystem for
 *    the surface-hugging arrows and by surfaceSystem's published pick.
 *  - $surfacePick publishes the point-cloud screen pick the imperative Viewer
 *    calls for drag&drop placement (getDropSurface*). surfaceSystem is the sole
 *    setter; the Viewer reads it through the instanceStore facade.
 */
export const $surfaceSampler = atom<SurfaceSampler | null>(null);

/** Surface hit from a screen ray — the client's point-cloud pick (getDropSurface). */
export type SurfaceHit = { position: Vec3; normal: Vec3 };
export const $surfacePick = atom<
  ((ndcX: number, ndcY: number, refine: boolean) => SurfaceHit | null) | null
>(null);
